import { createSelector } from '@reduxjs/toolkit'
import { getStage, getStagesByWorkflowId } from '../../getters'

export const selectStage = () => createSelector([getStage], (stage) => stage)

export const selectStagesByWorkflowId = createSelector(
  [getStagesByWorkflowId],
  (stages) => stages || []
)
